import { registerTour } from "../tourRegistry";

// This tour lands on /upkeep/reconciliation with NO account param, i.e. the
// reconciliation OVERVIEW hub (reconciliation.js: view = urlAccountId ? "detail"
// : "overview"). Every step below describes something that actually exists on
// that hub — the stat tiles, the "Needs reconciliation" list, and a per-account
// Reconcile button. The tour deliberately stops at the hub: opening an account's
// reconciliation needs an account context the tour can't assume, so the final
// step explains what a Reconcile click leads to rather than touring it.
function getSteps() {
  const totalSteps = 4;
  const stepCounter = (n) => `Step ${n} of ${totalSteps}`;

  return [
    {
      id: 'rec-hub',
      title: `Reconciliation <span class="t3-shepherd-step-count">${stepCounter(1)}</span>`,
      text: 'Reconciliation is how you check that your books match your bank. This page is your hub for every account you reconcile — it shows what needs attention and lets you start.',
      attachTo: { element: '[data-tour="rec-page"]', on: 'bottom' },
      buttons: [
        {
          text: 'Next',
          classes: 't3-shepherd-next-btn',
          action() { this.next(); },
        },
      ],
    },
    {
      id: 'rec-overview-stats',
      title: `Your reconciliation at a glance <span class="t3-shepherd-step-count">${stepCounter(2)}</span>`,
      text: 'These tiles summarize where things stand: how many accounts need reconciling, how many are overdue, how many are up to date, and how many imported transactions are still unmatched.',
      attachTo: { element: '[data-tour="rec-overview-stats"]', on: 'bottom' },
      buttons: [
        {
          text: 'Back',
          classes: 't3-shepherd-back-btn',
          action() { this.back(); },
        },
        {
          text: 'Next',
          classes: 't3-shepherd-next-btn',
          action() { this.next(); },
        },
      ],
    },
    {
      id: 'rec-overview-needs-list',
      title: `Accounts that need reconciling <span class="t3-shepherd-step-count">${stepCounter(3)}</span>`,
      text: 'Accounts that are due or overdue are listed here, with the most urgent first. Each row shows when it was last reconciled and its current status. Click a row to see that account\'s reconciliation history.',
      attachTo: { element: '[data-tour="rec-overview-needs-list"]', on: 'top' },
      buttons: [
        {
          text: 'Back',
          classes: 't3-shepherd-back-btn',
          action() { this.back(); },
        },
        {
          text: 'Next',
          classes: 't3-shepherd-next-btn',
          action() { this.next(); },
        },
      ],
    },
    {
      id: 'rec-overview-reconcile-btn',
      title: `Start a reconciliation <span class="t3-shepherd-step-count">${stepCounter(4)}</span>`,
      text: 'Click Reconcile on an account to open its reconciliation. There you enter the closing balance and date from your bank statement, then mark each transaction that appears on the statement as cleared until the two match.',
      attachTo: { element: '[data-tour="rec-overview-reconcile-btn"]', on: 'left' },
      buttons: [
        {
          text: 'Back',
          classes: 't3-shepherd-back-btn',
          action() { this.back(); },
        },
        {
          text: 'Done',
          classes: 't3-shepherd-next-btn',
          action() { this.complete(); },
        },
      ],
    },
  ];
}

registerTour({
  id: 'reconciliation',
  pathPattern: '/upkeep/reconciliation',
  getSteps,
  label: 'Reconciliation Tour',
});
